import { defineStore } from "pinia"
// import fetchWP from '@/utils/fetchWP'
import { useAppStore } from './app'

// using eval to bypass compile warning/errors
// const req = new fetchWP({
//     restURL: eval('lead_dialer_vars.api.url'),
//     restNonce: eval('lead_dialer_vars.api.nonce')
// })

export const useRoomsStore = defineStore("rooms", {
    state: () => {
        return {
            rooms: [],
            page_on_front: 0,
            loading: false,
            settings: null
        }
    },
    actions: {
        loadRooms: function() {
            this.app = useAppStore()
            this.loading = true
            this.app.get('meeting/rooms').then(response => {
                this.rooms = response.data.rooms
                // this.settings = response.data['100ms']
                this.page_on_front = response.data.page_on_front
                this.loading = false
            })
            .catch(error => {
                console.error(error)
                this.loading = false
            })
        },
        roomHeaderColor(room) {
            return room?.settings?.header_color?.hex
        },
        roomPrimaryColor(room) {
            return room?.settings?.primary_color?.hex
        },
    }
})